module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_9006.f11c52d4.png";